import React from 'react';
import { Badge } from 'reactstrap';

import { Desktop } from '../Common/const';

class QuestionRemaining extends React.Component {
  render() {
    // when clicked we need to color the right item
    let learningClass;
    let reviewClass;
    let newClass;
    switch (this.props.counterType) {
      case 'Learning':
        learningClass = 'clicked';
        break;
      case 'Review':
        reviewClass = 'clicked';
        break;
      case 'New':
        newClass = 'clicked';
        break;
      default:
    }
    if (this.props.clicked() === true) {
      learningClass = 'clicked';
      reviewClass = 'clicked';
      newClass = 'clicked';
    }

    if (!this.props.items) {
      return null;
    }
    return (
      <div className="questions-remaining row text-center">
        <Desktop>
          <div className="col-12 mb-3 " data-test="question-remaining-label">
            <b>Question Remaining</b>
          </div>
        </Desktop>

        <div className="col-4 d-flex flex-column align-items-center">
          <Badge color="danger" className={learningClass}>
            {this.props.items.learning}
          </Badge>
          Learning
        </div>

        <div className="col-4 d-flex flex-column align-items-center">
          <Badge color="info" className={reviewClass}>
            {this.props.items.review}
          </Badge>
          Review
        </div>

        <div className="col-4 d-flex flex-column align-items-center">
          <Badge color="success" className={newClass}>
            {this.props.items.new}
          </Badge>
          New
        </div>
      </div>
    );
  }
}

export default QuestionRemaining;
